// import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BreadcrumbGroup, {
  BreadcrumbGroupProps,
} from '@cloudscape-design/components/breadcrumb-group';

export default function Breadcrumbs() {
  const location = useLocation();
  const navigate = useNavigate();
  let items: BreadcrumbGroupProps.Item[] = [];
  const handleNavigate = (link: string) => navigate(link);
  const handleClick = (
    event: CustomEvent<BreadcrumbGroupProps.ClickDetail>
  ) => {
    // console.log(event)
    event.preventDefault();
    // setActiveHref(event.detail.href)
    handleNavigate(event.detail.href)

  };
  try {
    const pathnames = location.pathname.split('/').filter((x) => x);

    // Generate breadcrumb items based on the current path
    items = [
      { text: 'X2nSat, Inc', href: '/' },
      ...pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
        return { text: capitalize(value), href: to };
      }),
    ];
  } catch (error) {
    console.error('Error generating breadcrumb items:', error);
    // You can set a default breadcrumb or leave it empty based on your requirements
    items = [{ text: 'X2nSat, Inc', href: '/' }];
  }

  return <BreadcrumbGroup items={items} onClick={handleClick}/>;
}

// Helper function to capitalize the first letter of a string
function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
